import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import {RdService} from '../../../core/services/rd.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';

@Component({
    selector: 'cadastrar-senha',
    templateUrl: './cadastrar-senha.component.html',
    styleUrls: ['./cadastrar-senha.component.sass']
})
export class CadastrarSenhaComponent implements OnInit {
    public form: FormGroup;
    public onSubmit = false;
    public token: string;
    public data: any;
    isMobile = false;
    public innerWidth: any;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    constructor(
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public route: ActivatedRoute,
        public toast: ToastrService,
        public cepService: CepService,
        public formBuilder: FormBuilder,
        public rdService: RdService) {

        this.token = this.route.snapshot.queryParams.token;
        this.data = jwt_decode(this.token.toString());

        this.form = formBuilder.group({
            associado: new FormControl(false, [Validators.required]),
            codigoPropostaSite: new FormControl(this.data.id, [Validators.required]),
            confirmaSenha: new FormControl(null, [Validators.required]),
            novaSenha: new FormControl(null, [Validators.required]),
            token: new FormControl(this.token, [Validators.required]),
        }, {
            validator: (group: FormGroup) => {
                this.validaSenha(group);
            }
        });
    }

    validaSenha(group: FormGroup) {
        const pass = group.get('novaSenha').value;
        const confirmPass = group.get('confirmaSenha').value;

        if (pass !== confirmPass) {
            group.get('confirmaSenha').setErrors({ notSame: true });
        }
    }

    getLastEmail() {
        return JSON.parse(localStorage.getItem('mtl.proposta')).email;
    }

    async ngOnInit() {
        this.handleMobile();
    }

    private handleMobile() {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1026) {
            this.isMobile = true;
            return;
        }
        this.isMobile = false;
    }

    getErrorMessage(field: string) {
        if (!this.onSubmit) {
            return '';
        }

        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('cpf') ? 'CPF inválido' :
                input.hasError('invalidDate') ? 'Insira uma data válida.' :
                    input.hasError('notSame') ? 'E-mail não confere.' :
                        input.hasError('email') ? 'E-mail inválido.' :
                            input.hasError('senhaNaoConfere') ? 'Senha não confere.' :
                                '';
    }

    async submit() {
        this.onSubmit = true;

        if (this.form.valid) {
            await this.propostaService.finalizarPropostaSite(this.form.value, this.data.id);
            const email = this.getLastEmail();
            await this.rdService.carrinhoLogin(email);
            await this.router.navigate(['confirmacao-compra']);
        }
    }
}
